import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function actionCardAction(theme: Theme): ComponentStyle {
  return {
    componentName: 'actionCardAction',
    baseStyle: {
      color: theme.colors.hype.background70
    },
    variants: {}
  };
}
